import React from 'react'
import {View} from 'react-native'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'
import {type NativeStackScreenProps} from '@react-navigation/native-stack'

import {type CommonNavigatorParams} from '#/lib/routes/types'
import {
  useTrendingSettings,
  useTrendingSettingsApi,
} from '#/state/preferences/trending'
import * as SettingsList from '#/screens/Settings/components/SettingsList'
import {atoms as a} from '#/alf'
import * as Admonition from '#/components/Admonition'
import * as Toggle from '#/components/forms/Toggle'
import {Trending3_Stroke2_Corner1_Rounded as TrendingIcon} from '#/components/icons/Trending'
import * as Layout from '#/components/Layout'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'PremiumSettings'>

export function BateskyCustomizationsSettingsScreen({}: Props) {
  const {_} = useLingui()
  const {trendingDisabled} = useTrendingSettings()
  const {setTrendingDisabled} = useTrendingSettingsApi()

  const onToggleTrending = React.useCallback(() => {
    setTrendingDisabled(!trendingDisabled)
  }, [trendingDisabled, setTrendingDisabled])

  return (
    <Layout.Screen>
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          <Layout.Header.TitleText>
            <Trans>Batesky Customizations</Trans>
          </Layout.Header.TitleText>
        </Layout.Header.Content>
        <Layout.Header.Slot />
      </Layout.Header.Outer>
      <Layout.Content>
        <SettingsList.Container>
          <SettingsList.Group>
            <SettingsList.ItemIcon icon={TrendingIcon} />
            <SettingsList.ItemText>
              <Trans>Trending Topics</Trans>
            </SettingsList.ItemText>
            <Toggle.Item
              type="checkbox"
              name="trending_topics_enabled"
              label={_(msg`Show Bluesky trending topics`)}
              value={!trendingDisabled}
              onChange={onToggleTrending}
              style={[a.w_full, a.gap_md]}>
              <Toggle.LabelText style={[a.flex_1]}>
                <Trans>Show Bluesky trending topics</Trans>
              </Toggle.LabelText>
              <Toggle.Platform />
            </Toggle.Item>
          </SettingsList.Group>
          <SettingsList.Item>
            <Admonition.Outer type="tip" style={[a.flex_1]}>
              <Admonition.Row>
                <Admonition.Icon />
                <View style={[a.flex_1, a.gap_sm]}>
                  <Admonition.Text>
                    <Trans>
                      When enabled, trending topics from Bluesky will appear on
                      the right-hand side of your timeline.
                    </Trans>
                  </Admonition.Text>
                </View>
              </Admonition.Row>
            </Admonition.Outer>
          </SettingsList.Item>
        </SettingsList.Container>
      </Layout.Content>
    </Layout.Screen>
  )
}
